import { gql } from '@apollo/client'
import { initializeApollo } from 'gql/client'
import { Page } from 'components/organisms'
import { PAGINA, PAGINE_CATCH_ALL } from 'utils/queries'
import PlaceholderReact from 'components/molecules/PlaceholderReact/PlaceholderReact'
import { NextWrapper } from 'data-fetching-wrapper'

function CatchAllPage({ pagina }) {
  return (
    <Page pagina={pagina}>
      <PlaceholderReact contentTypeId={pagina.contentTypeId} objectId={pagina.pk} pkey="content" />
    </Page>
  )
}

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  for (const locale of locales) {
    const client = initializeApollo(null, null, null, locale)
    const {
      data: { pagine },
    } = await client.query({
      query: gql`
        ${PAGINE_CATCH_ALL}
      `,
    })
    pagine?.edges
      .filter((x) => x.node.url !== '')
      .forEach((x) =>
        paths.push({ params: { path: x.node.url.split('/').slice(1), locale: locale } })
      )
  }

  return {
    paths,
    fallback: 'blocking',
  }
}, '/[path]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { path }, preview, previewData, locale }) => {
    const route = '/' + path.join('/')

    const client = initializeApollo(null, null, null, locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: gql`
        ${PAGINA.replace('__chiave__', '').replace('__path__', route)}
      `,
      variables: { preview: preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina },
      revalidate: 60 * 10,
    }
  }
)

export default CatchAllPage
